import storage from 'store';
import router from './router';
import { usePermissionStore } from './stores/permissionStore';
router.beforeEach(async (to, from, next) => {
    const permissionStore = usePermissionStore();
    // 获取token
    let token = storage.get('token');
    // 需要登录权限
    if (!to.meta.not_auth) {
        // 有token
        if (token) {
            // 等待获取用户信息
            let status = await permissionStore.getUserInfoFun();
            await permissionStore.getCommonConfig()
            if(status){
                next();
            }else{
                storage.remove('token');
                router.push('/login');
            }
        } else {
            router.push('/login');
        }
    } else {
        next();
    }
});
